$(function () {
	slider_init();

	$('.specialist-itm').on('click', (e) => {
		let self = $(e.currentTarget)

		if (!is_tablet) {
			let index = self.parent().index(),
				slider = $('.specialist-slider')

			slider.trigger("to.owl.carousel", index)

			return true;
		}

		$('.specialist-itm').removeClass("hover");
		self.addClass('hover');
	});

});

const slider_init = () => {

	$('.itm-format-slider').owlCarousel({
		items: 2,
		nav: true,
		loop: false,
		smartSpeed: 1000,
		dots: false,
		responsive: {
			0: {items: 1, margin: 16},
			600: {items: 2, margin: 0},
		},
	});

	$('.event-slider').owlCarousel({
		items: 3,
		nav: true,
		loop: false,
		smartSpeed: 1000,
		dots: false,
		responsive: {
			0: {items: 1, margin: 16},
			600: {items: 3, margin: 0}
		},
	});

	$('.event-slider-big').owlCarousel({
		items: 2,
		nav: true,
		loop: false,
		smartSpeed: 1000,
		dots: false,
		responsive: {
			0: {items: 1, margin: 16},
			600: {items: 2, margin: 0}
		},
	});

	let specialistTimeout = false;
	$('.specialist-slider').owlCarousel({
		items: 3,
		nav: true,
		loop: true,
		autoplay: true,
		autoplayTimeout: 10000,
		smartSpeed: 300,
		autoplayHoverPause: true,
		dots: false,
		responsive: {
			0: {items: 1, margin: 16},
			600: {items: 2, margin: 0},
			1100: {items: 3}
		}, onChanged: (e) => {
			let block = $(e.currentTarget),
				count = e.relatedTarget._current,
				items_active = block.find('.owl-item')

			block.find('.specialist-itm').removeClass("active");

			if (!is_tablet) count++

			$('.specialist-itm').removeClass("hover");

			clearTimeout(specialistTimeout);
			specialistTimeout = setTimeout(() => {
				items_active.eq(count).find('.specialist-itm').addClass("active");
			}, 300)
		}
	});

	$('.grid-tiles-slider').owlCarousel({
		items: 1,
		nav: true,
		loop: true,
		autoplay: true,
		autoplayTimeout: 10000,
		smartSpeed: 300,
		autoplayHoverPause: true,
		dots: true,
		animateOut: 'fadeOut',
		animateIn: 'fadeIn',
		onTranslate: function () {
			$('.owl-next, .owl-prev').prop('disabled', true); // Блокировка кнопок
		},
		onTranslated: function () {
			$('.owl-next, .owl-prev').prop('disabled', false); // Разблокировка кнопок
		}
	})

	$('.cocktail-slider').owlCarousel({
		items: 2,
		nav: false,
		smartSpeed: 300,
		dots: true,
		margin: 10
	})

	$('.cocktail-slider-itm').on('click', (e) => {
		let self = $(e.currentTarget),
			index = self.parent().index()

		$('.cocktail-slider').trigger("to.owl.carousel", Math.ceil(index/2))
	});

	$('.see-also-list').owlCarousel({
		items: 3,
		nav: true,
		smartSpeed: 300,
		loop: true,
		dots: false,
		margin: 60,
		responsive: {
			0: {items: 1, margin: 16, dots: true, nav: false},
			600: {items: 2, margin: 24, dots: false, nav: true},
			1100: {items: 3, margin: 60},
		},
	})


	if (is_mobile) {
		$('.front-advantages-grid').owlCarousel({
			items: 1,
			nav: false,
			loop: false,
			smartSpeed: 1000,
			dots: true,
			margin: 16,
			responsive: {
				0: {},
				600: {},
			},
		});

		$('.estimate-grid').owlCarousel({
			items: 2,
			nav: false,
			loop: false,
			smartSpeed: 1000,
			dots: true,
			margin: 8,
			responsive: {
				0: {},
				600: {},
			},
		});

	}
}